import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FiltersModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/filters.module';
import { ListNavigationModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/list-navigation/list-navigation.module';
import { SubscriptionModule } from '@suvo/frontend/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/subscription/modules/subscription.module';
import { environment } from '$env';
import { SharedModule } from '../../../shared/shared.module';
import { FILTERS_SECTIONS } from '../filters/constants/filters-sections.const';
import { AccountSidenavWidgetComponent } from './components/account-sidenav-widget/account-sidenav-widget.component';
import { FooterComponent } from './components/footer/footer.component';
import { MainOutletComponent } from './components/main-outlet/main-outlet.component';
import { MainSidenavComponent } from './components/main-sidenav/main-sidenav.component';
import { NavigationOutletModule } from './components/navigation-outlet/navigation-outlet.module';

@NgModule({
  declarations: [
    MainOutletComponent,
    MainSidenavComponent,
    FooterComponent,
    AccountSidenavWidgetComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FiltersModule.forRoot({
      filtersSections: FILTERS_SECTIONS,
      dataServiceApi: environment.cprServiceApi,
      reverseUrlParts: true,
    }),
    ListNavigationModule,
    NavigationOutletModule,
    SubscriptionModule,
  ],
  exports: [MainOutletComponent],
})
export class AppOutletModule {}
